<template>
  <aside class="h-full block overflow-hidden bg-white border rounded pb-12">
    <div class="h-52 border-b border-ricoma-gray-300">
      <img
        class="object-cover object-center w-full h-full"
        :src="accessory ? accessory.thumbnail_path : ''"
        alt="ad"
      />
    </div>
    <div class="px-4 py-4">
      <h6 class="mb-4 font-bold">
        {{ accessory.name }}
      </h6>
      <p class="mb-4">
        {{ accessory.description }}
      </p>
      <a :href="accessory.shop_link" target="_blank" class="cursor-pointer button">
        {{ $t('dashboard.ad.link') }}
        <VSvgIcon name="arrow-right" class="ml-2" />
      </a>
    </div>
  </aside>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'DashboardAdCard',
  props: { accessory: Object },
  components: { VSvgIcon },
};
</script>
